import React from 'react';
import { useSpring, animated } from 'react-spring';

const DisableMap = (props: ExamplePropTypes) => {
  const { disable } = props;
  const animation = useSpring({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    pointerEvents: disable ? 'auto' : 'none',
    opacity: disable ? 1 : 0,
    cursor: disable ? 'wait' : '',
  });
  return <animated.div style={animation}></animated.div>;
};

interface ExamplePropTypes {
  disable: boolean;
}

export default DisableMap;
